module.exports = __webpack_public_path__ + "img/g-logo.d059067f.png";